

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ContactAnonModule } from '@/store/modules/contactAnon';
import AnonJobWorkerOfferContactConfirmationReply from '@/models/AnonJobWorkers/AnonJobWorkerOfferContactConfirmationReply';
import PageNames from '@/router/PageNames';
import ListUtils from '@/lib/listUtils';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AppModule } from '@/store/modules/app';

@Component({
    name: 'ContactOfferConfirmationConfirmDecline'
})
export default class extends GiganautVueDialog {

  public dialog = false;
  public request: AnonJobWorkerOfferContactConfirmationReply = new AnonJobWorkerOfferContactConfirmationReply();

  get allowDeclineOffer () {
      return ContactAnonModule.offerConfirmation.allowDeclineOffer;
  }

  get offerConfirmation() {
    return ContactAnonModule.offerConfirmation;
  }

  get buttonLabel() {
    if (this.allowDeclineOffer) {
      return "CONFIRM/DECLINE";
    } else {
      return "CONFIRM";
    }    
  }

  get dialogTitle() {
    if (this.allowDeclineOffer) {
      return "Confirm or Decline Offer";
    } else {
      return "Confirm Offer";
    }    
  }

  get submitButtonLabel() {
    if (this.allowDeclineOffer) {
      return "SUBMIT";
    } else {
      return "CONFIRM";
    }   
  }
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (!this.allowDeclineOffer) {
        //Automatically tick the hidden tickbox
        this.request.confirmed = true;
      }
    }
  }

  get loading() {
    return ContactAnonModule.loadingDialog;
  }

  get declinedReasons() {
    return ListUtils.jobWorkerOfferContactDeclinedReasons();
  }

  get agency() {
    return AppModule.currentAgencyContext;
  }
	  
  async submit() { 
     if (!(this.$refs.form as any).validate()) {
      return;
    }
    await ContactAnonModule.offerContactConfirmation(this.request);
    this.dialog = false;
    if (ContactAnonModule.isError) {
       this.$router.push({ name: PageNames.ContactError });
    }
  }
}
